import { FC, createPortal } from "preact/compat";
import { useDocumentPiP } from "~/hooks";
import { DocumentPictureInPictureProps } from "./interfaces";

const DocumentPictureInPicture: FC<DocumentPictureInPictureProps> = ({
    children,
}) => {
    const { pipWindow } = useDocumentPiP();
    const pip = pipWindow.value;

    if (!pip) {
        return null;
    }

    return createPortal(children, pip.document.body);
};

export default DocumentPictureInPicture;
